import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RiskquizComponent} from './riskquiz/riskquiz.component';
import { RiskscoreComponent } from './riskscore/riskscore.component';
import { MotivationquizComponent } from './motivationquiz/motivationquiz.component';
import { MotivationscoreComponent } from './motivationscore/motivationscore.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DemographyquizComponent } from './demographyquiz/demographyquiz.component';
import { DemographyscoreComponent } from './demographyscore/demographyscore.component';
import { LifestylequizComponent } from './lifestylequiz/lifestylequiz.component';
import { ProgramgoalsComponent } from './programgoals/programgoals.component';
import { FoodQuizComponent } from './food-quiz/food-quiz.component';
import { PreprogramComponent } from './preprogram/preprogram.component';
import { PhoneandemailComponent } from './phoneandemail/phoneandemail.component';
import { RegisterprogramgoalsComponent } from './registerprogramgoals/registerprogramgoals.component';
import { SdohquizComponent } from './sdohquiz/sdohquiz.component';
import { Sdohquiz2Component } from './sdohquiz2/sdohquiz2.component';
import { ComorbidityquizComponent } from './comorbidityquiz/comorbidityquiz.component';
import { PreferencequizComponent } from './preferencequiz/preferencequiz.component';


// import { NgbdModalContent } from '../alert-component';


@NgModule({
  declarations: [RiskquizComponent, RiskscoreComponent, MotivationquizComponent, 
    MotivationscoreComponent, DemographyquizComponent, DemographyscoreComponent, LifestylequizComponent, ProgramgoalsComponent, FoodQuizComponent, PreprogramComponent, PhoneandemailComponent, RegisterprogramgoalsComponent, SdohquizComponent, Sdohquiz2Component, ComorbidityquizComponent, PreferencequizComponent,],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule.forRoot(),
  ],
  exports: [
    RiskquizComponent,RiskscoreComponent,MotivationquizComponent,
    MotivationscoreComponent, DemographyquizComponent, DemographyscoreComponent, 
    SdohquizComponent, Sdohquiz2Component, ComorbidityquizComponent,
    PreferencequizComponent
  ],
  entryComponents: []

})
export class QuestionaireModule { }
